module.exports = __webpack_public_path__ + "img/Training_courses_img_1.9842e92b.jpg";